export default __webpack_public_path__ + "static/media/sz.8fc8a42d.svg";